import { GET_ALL_CONTENT_SUCCESS } from '../actions/actionTypes';

export default function allContent(state = [], action) {
  switch (action.type) {
    case GET_ALL_CONTENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
